import type { PadelGamePlayerItem, PadelSessionListItem } from '@/services/padelService';

export const formatPadelSessionStatus = (status: string) => {
  switch (status) {
    case 'completed':
      return 'Selesai';
    case 'in_progress':
      return 'Berlangsung';
    default:
      return 'Akan Datang';
  }
};

export const padelSessionStatusBackgroundAndForeground = (status: string) => {
  switch (status) {
    case 'completed':
      return 'bg-[#EFF6FF] text-[#22C55E] text-[10px] font-extrabold';
    case 'in_progress':
      return 'bg-[#FEF0EA] text-[#F59E0B] text-[10px] font-extrabold';
    default:
      return 'bg-[#FEF0EA] text-[#6B7280] text-[10px] font-extrabold';
  }
};

export const countCompletedRounds = (session: PadelSessionListItem): number =>
  (session.games ?? []).filter((g) => g.status === 'completed').length;

export const formatPadelGameStatus = (status: string) => {
  switch (status) {
    case 'completed':
      return 'Selesai';
    case 'in_progress':
      return 'Berlangsung';
    default:
      return 'Terjadwal';
  }
};

export const padelGameStatusBackgroundAndForeground = (status: string) => {
  switch (status) {
    case 'completed':
      return 'bg-[#EFF6FF] text-[#22C55E] text-[10px] font-extrabold';
    case 'in_progress':
      return 'bg-[#FEF0EA] text-[#F59E0B] text-[10px] font-extrabold';
    default:
      return 'bg-[#FEF0EA] text-[#6B7280] text-[10px] font-extrabold';
  }
};

export const formatPadelSessionTypeLabel = (sessionType: string, rotationFormat?: string) => {
  if (rotationFormat === 'round_robin') return 'Round Robin';
  if (rotationFormat === 'americano') return 'Americano';
  if (rotationFormat === 'mexicano') return 'Mexicano';
  switch (sessionType) {
    case 'generated':
      return 'Americano';
    case 'manual':
      return 'Manual';
    default:
      return sessionType;
  }
};

export const formatScoringType = (type: string) => {
  switch (type) {
    case 'points':
      return 'Poin';
    case 'sets':
      return 'Set';
    case 'time':
      return 'Waktu';
    default:
      return type;
  }
};

export const playersLabel = (players: PadelGamePlayerItem[]) =>
  players.map((p) => p.playerName).join(' & ');

export const playersFirstNameLabel = (players: PadelGamePlayerItem[]) =>
  players.map((p) => (p.playerName || '').trim().split(/\s+/)[0] || '-').join(' & ');

export const PADEL_AVATAR_COLORS = [
  'bg-[#FF5A1F] text-white',
  'bg-[#1E66F5] text-white',
  'bg-[#16A34A] text-white',
  'bg-[#9333EA] text-white',
  'bg-[#CA8A04] text-white',
  'bg-[#DB2777] text-white',
  'bg-[#0891B2] text-white',
  'bg-[#DC2626] text-white',
];

export const padelAvatarColor = (key: string): string => {
  const hash = (key || '?').split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return PADEL_AVATAR_COLORS[hash % PADEL_AVATAR_COLORS.length];
};

export const padelInitials = (name: string): string => {
  const clean = (name || '').trim();
  if (!clean) return '?';
  return clean.charAt(0).toUpperCase();
};

export const padelShortName = (name: string): string => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '-';
  if (parts.length === 1) return parts[0];
  const last = parts[parts.length - 1];
  return `${parts[0]} ${last.charAt(0).toUpperCase()}.`;
};
